import * as cheminFerConfig from '@/configuration/presse/parution/cheminFerConfig';

export const ADD_PARUTION = {
  title: {
    ajout: 'Création d\'une parution ',
    edit: 'Modification d\'une parution ',
  },
  breadcrumb: {
    ajout: 'Création d\'une parution',
    edit: 'Modification d\'une parution',
    racine: 'Accueil',
    liste: 'Liste des parutions',
  },
  actions: {
    cancel: 'Annuler',
    addPage: 'Ajouter une page',
  },
  notifications: {
    successCreation: 'Création de la parution réalisée avec succès.',
    successChange: 'Modification de la parution réalisée avec succès.',
  },
  information: {
    title: 'Information générales',
    code: 'Code',
    numParution: 'Numéro',
    nomParution: 'Nom',
    dateEnvoiCF: 'Date envoi CF',
    dateEnvoiBAT: 'Date envoi BAT',
    dateRemiseEltTech: 'Date de bouclage',
    dateParution: 'Date parution',
    produit: 'Produit',
  },
  pageParution: {
    title: 'Pages de la parution',
    ordre: 'Ordre',
    nom: 'Nom',
    largeurUtile: 'Larg. utile (mm)',
    hauteurUtile: 'Haut. utile (mm)',
    largeur: 'Larg. (mm)',
    hauteur: 'Haut. (mm)',
    margeGauche: 'Marge gauche (mm)',
    margeHaute: 'Marge haute (mm)',
    surface: 'Surface',
    emplacement: 'Emplacement',
    couleurEncart: 'Couleur',
    actions: {
      delete: 'Supprimer',
      dupliquer: 'Dupliquer',
      modifications: 'Modifier',
    },
    popUpDuplication: {
      title: 'Dupliquer les pages',
      qteACreer: 'Quantité',
    },
    popUpModification: {
      title: 'Modifier les pages de la parution',
    },
  },
  error: {
    champsObligatoire: 'Le champs {name} est obligatoire',
    cantModifySurface: 'La somme des surfaces disponibles pour l\'emplacement "{emplacement}" dans la parution "{parutionCode}" est inférieur à la somme des ventes après les modifications : anciennes surfaces {sommeAnciensRatios}, nouvelles surfaces : {sommeNouveauRatios}',
    cantModifyProduitId: 'Impossible de modifier le produit de la partution {parutionCode} car des ventes existent pour celle-ci',
    ordre: 'Ordre de la liste des pages',
    numPageParution: 'Num. de la liste des pages',
    nom: 'Nom  de la liste des pages',
    deleteForbidden: 'Suppression impossible, il existe des lignes de vente.',
    largeurUtile: 'Larg. utile  de la liste des pages',
    hauteurUtile: 'Haut. utile  de la liste des pages',
    largeur: 'Larg.  de la liste des pages',
    hauteur: 'Haut.  de la liste des pages',
    margeGauche: 'Marge gauche  de la liste des pages',
    margeHaute: 'Marge haute  de la liste des pages',
    surface: 'Surface  de la liste des pages',
    emplacement: 'Emplacement  de la liste des pages',
    couleurEncart: 'Couleur  de la liste des pages',
    orderStart1: 'L\'ordre des pages de la parution {nomParution} doit commencer par 1.',
    orderSuiteNumber: 'L\'ordre des pages de la parution {nomParution} doit se suivre. Ex: 1,2,3,4...',
  },
};

export const LISTE_PARUTION = {
  title: 'Liste des parutions',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des parutions',
  },
  popUpArchivage: {
    title: 'Voulez-vous archiver cette parution ?',
  },
  popUpDesarchivage: {
    title: 'Voulez-vous désarchiver cette parution ?',
  },
  actions: {
    add: 'Nouvelle parution',
    delete: 'Supprimer',
    search: 'Rechercher',
    filtre: 'Filtre',
    generationParutions: 'Générer en masse',
    duplicationParutions: 'Dupliquer',
    editionMasse: 'Générer édition',
    suppressionMasse: 'Supprimer',
  },
  editions: {
    editionBatAttenteRetour: 'BAT en attente retour',
    editionChemindeFer: 'Chemin de fer',
    editionChemindeFerSansPageVide: 'Chemin de fer sans page vide',
    recapMaquettiste: 'Récapitulatif maquettiste',
    realise: 'Réalisé',
    editionReleveDePub: 'Relevé de publicité',
    editionReleveDePubRapproche: 'Relevé de publicité rapproché',
    editionParutionReporting: 'Suivi technique presse',
  },
  suppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette parution ?',
    titleMulti: 'Êtes-vous sûr de vouloir supprimer ces parutions ?',
    errorDelete: 'Impossible de supprimer la parution car elle possède des ventes.',
    sucess: {
      parutionDelete: 'Parution supprimée avec succès',
      parutionMulti: 'Les parutions ont été supprimées avec succès.',
    },
  },
  tab: {
    code: 'Code',
    numParution: 'Numéro',
    nomParution: 'Nom',
    produit: 'Produit',
    dateEnvoiCF: 'Date envoi CF',
    dateEnvoiBAT: 'Date envoi BAT',
    dateRemiseEltTech: 'Date de bouclage',
    dateParution: 'Date parution',
    rav: 'RAV',
    infoDispo: 'Disponibilité : {stock}/{total}',
    bat: 'BAT',
    factures: 'Fac.',
    commandesAFacturer: 'Cmd. à Fac.',
    planMedia: 'PM',
    cheminFer: 'Chem. Fer',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    code: 'Code de la parution',
    nomParution: 'Nom de la parution',
    periodeDateEnvoiCF: 'Date envoi CF',
    periodeDateEnvoiBAT: 'Date envoi BAT',
    periodeDateRemiseEltTech: 'Date de remise',
    periodeDateParution: 'Date parution',
    produits: 'Produit(s)',
    typeProduits: 'Type(s) de produit',
    actif: 'Actif',
    agence: 'Agence(s)',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  popUpVente: {
    title: 'Liste des ventes pour la parution {code}, du {date}',
    produit: 'Produit : {produit}',
    encart: 'Encart : {encart} - {prix}€',
    commande: 'Commande',
    noVente: 'Il n\'y a pas de commande pour cette parution',
  },
  popUpValidationDate: {
    title: 'Validation date definitive parution',
    dateDefinitif: 'Date définitive',
  },
  generationParutions: {
    titleGenration: 'Génération des parutions',
    titleDuplication: 'Duplication des parutions',
    premierNumero: 'Premier numéro',
    qteACreer: 'Quantité à créer',
    periodicite: 'Périodicité',
    nbJours: 'Nombre de jours',
    nbMois: 'Nombre de mois',
  },
};

export const DETAIL_PARUTION = {
  title: 'Détail {nom}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des parutions',
    detail: 'Détail parution',
  },
  actions: {
    edit: 'Modifier',
    edition: 'Edition',
  },
  information: {
    title: 'Information générales',
    code: 'Code :',
    numParution: 'Numéro :',
    nomParution: 'Nom :',
    dateEnvoiCF: 'Date envoi CF :',
    dateEnvoiBAT: 'Date envoi BAT :',
    dateRemiseEltTech: 'Date de bouclage :',
    dateParution: 'Date parution :',
    produit: 'Produit :',
    nomSupport: 'Support :',
  },
  accesRapide: {
    factures: 'Voir les factures',
    commandes: 'Voir les commandes',
    commandesAFacturer: 'Voir les commandes à facturer',
    planMedia: 'Voir les plan média',
    bat: 'Voir les BAT',
  },
};

export const BAT = {
  title: 'Suivi des BAT',
  breadcrumb: {
    edit: 'Suivi BAT',
    racine: 'Accueil',
    liste: 'Liste des parutions',
  },
  actions: {
    setVisuelDemande: 'Visuel demandé',
  },
  columns: {
    demandeVisuel: 'Demande de visuel',
    envoiBAT: 'Envoi de BAT',
    attenteRetourBAT: 'Attente retour BAT signé',
    batSigne: 'BAT signé',
  },
  card: {
    encart: 'Encart : ',
    parution: 'Parution : ',
    visuelDemande: 'Visuel demandé',
    visuelRecu: 'Visuel reçu',
    batDemande: 'Bat demandé',
    batRecu: 'Bat reçu',
    dateAccord: 'Date d\'accord',
    envoyerDemande: 'Envoyer la demande par email',
    envoyer: 'Envoyer',
    commentaire: 'Commentaire :',
    popUpMail: {
      title: 'Rédiger votre email',
      inclureBat: 'Inclure l\'édition BAT',
      contactTitle: 'Contacts BAT',
    },
    transmisPAO: 'Transmis PAO',
    validationVRP: 'Validation VRP',
    attenteRetourBAT: 'Attente Retour BAT',
    envoiBAT: 'Envoi du BAT',
  },
  popUpUpload: {
    title: 'Information sur l\'accord du client',
    accordTelephonique: 'Accord téléphonique',
    commentaireAccord: 'Commentaire',
    dateAccord: 'Date d\'accord',
  },
};

export const CHEMIN_FER = {
  title: 'Chemin de fer parution n°{code}',
  breadcrumb: {
    edit: 'Chemin de fer parution n°{code}',
  },
  actions: {
    reserverEncart: 'Réserver un encart',
    [cheminFerConfig.VIEW_DISPO]: 'Afficher les encarts possibles à placer',
    [cheminFerConfig.VIEW_ALL]: 'Voir tous les encarts',
    [cheminFerConfig.VIEW_PLACER]: 'Voir tous les encarts placés',
    [cheminFerConfig.VIEW_OF_PAGE]: 'Voir les encarts de la page',
    placer: 'Placer',
    supprimerPlacement: 'Supprimer le placement',
    voirPage: 'Voir la page',
  },
  titleCurrentPage: 'Page n°{pageNumber} sur {pageMax}',
  titleListeEncart: {
    [cheminFerConfig.VIEW_DISPO]: 'Liste des encarts disponibles pour cette page :',
    [cheminFerConfig.VIEW_ALL]: 'Liste des encarts vendu :',
    [cheminFerConfig.VIEW_PLACER]: 'Liste des encarts placé dans le chemin de fer :',
    [cheminFerConfig.VIEW_OF_PAGE]: 'Liste des encarts placé dans la page :',
  },
  titleCommande: 'Commande n°',
  libelleProduit: 'Produit :',
  libelleEncart: 'Encart :',
  dateParution: 'Date de la parution :',
  pasDeVisuel: 'Pas de visuel disponible',
  plusEncartAPlacer: 'Il n\'y a plus d\'encart à placer',
  encartReserve: 'Encart reservé',
  multiPage: 'Multi-pages',
  monoPage: 'Mono-page',
  infosParution: {
    title: 'Informations sur la parution',
  },
  popUpEncart: {
    title: 'Modification de l\'encart',
    libelleRegroupement: 'Produit',
    libelleEncart: 'Description',
  },
  notifications: {
    successSauvegarde: 'Sauvegarde du chemin de fer réalisée avec succès.',
  },
  errors: {
    libelleRegroupement: 'Produit de l\'encart réservé',
    libelleEncart: 'Description de l\'encart réservé',
  },
};
